import { Link } from 'react-router-dom';
import { HourglassIcon } from 'lucide-react';
import { PageHeader } from './PageHeader';
import { EmptyState } from './EmptyState';
import { btnSecondary } from './styles';
import { ADMIN_BASE } from '../../utils/hosts';
type Props = {
  title: string;
  description: string;
  /** 'page' = een eigen scherm met kop; 'inline' = alleen het blok (bijv. een tabblad in Instellingen). */
  variant?: 'page' | 'inline';
};

/**
 * Een onderdeel dat al in het menu staat maar nog niet gebouwd is (BEHEER-PLAN §8).
 * Zegt wat het straks doet, in plaats van een 404 of een leeg scherm.
 */
export function ComingSoon({
  title,
  description,
  variant = 'page'
}: Props) {
  const block = <EmptyState icon={HourglassIcon} title="Komt binnenkort" text={`${description} Dit komt met de salonversie van het beheer, na de livegang van de webshop.`} action={variant === 'page' ? <Link to={ADMIN_BASE} className={btnSecondary} data-id="element-4915" data-mp="25geupl27nk7n">
            Naar het overzicht
          </Link> : undefined} data-id="element-4914" data-mp="1wexk2i7koaqc" />;
  if (variant === 'inline') return block;
  return <div data-id="element-4916" data-mp="2950cke2pne4b">
      <PageHeader title={title} data-id="element-4917" data-mp="296l4dvxn4iyh" />
      {block}
    </div>;
}